import Table from 'common/table/table';
import { ThemeHeader } from 'common/table/table-helper';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedNumber, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Col, Div, FormItem, FormText, Row, SubTitle } from 'ui';

const Wrapper = styled(Div)`
  background-color: #fff;
  margin-bottom: 10px;
`;

const TaskList = ({
  taskList,
  intl,
}) => {
  const { operations = [] } = taskList;
  const {
    description,
    laborTime,
    travelTime,
    travelDistance,
    expenses,
    allowance,
    environmental,
    chemAnalysis,
    refrigrant,
  } = taskList;

  const getOperationsColumns = () => [
    {
      id: 'operations',
      displayName: intl.formatMessage({ id: 'order.taskList.OPERATIONS' }),
      fieldName: 'description',
      tooltip: row => row.description,
    },
  ];

  const translateUnit = (uom) => {
    const translatableUoms = ['STD', 'KMT', 'MIL'];
    if (translatableUoms.includes(uom)) {
      return intl.formatMessage({
        id: `equipment.taskList.uom.${uom}`,
      });
    }
    return uom;
  };

  const renderHeader = () => <ThemeHeader inlineTable={true}>
    {intl.formatMessage({ id: 'order.taskList.OPERATIONS' })}
  </ThemeHeader>;

  return (
    <Div marginTop={45}>
      <SubTitle>{intl.formatMessage({ id: 'common.titles.TASKLIST' })}</SubTitle>
      <Div marginBottom={10}>
        <Row type='flex' gutter={16} marginRight={0}>
          <Col md={6} sm={24} xs={24} paddingRight={55}>
            <FormItem label={intl.formatMessage({ id: 'taskList.TYPES' })} colon={false}>
              <FormText>{description}</FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.LABOR_TIME' })} colon={false}>
              <FormText>
                {laborTime.value &&
                  <span>
                    <FormattedNumber value={laborTime.value} />
                    {` ${translateUnit(laborTime.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.TRAVEL_TIME' })} colon={false}>
              <FormText>
                {travelTime.value &&
                  <span>
                    <FormattedNumber value={travelTime.value} />
                    {` ${translateUnit(travelTime.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem
              label={intl.formatMessage({ id: 'taskList.TRAVEL_DISTANCE' })}
              colon={false}
            >
              <FormText>
                {travelDistance.value &&
                  <span>
                    <FormattedNumber value={travelDistance.value} />
                    {` ${translateUnit(travelDistance.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.EXPENSES' })} colon={false}>
              <FormText>
                {expenses.value &&
                  <span>
                    <FormattedNumber value={expenses.value} />
                    {` ${translateUnit(expenses.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16} marginRight={0}>
          <Col md={6} sm={24} xs={24} /> {/* to add blank column */}
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.ALLOWANCE' })} colon={false}>
              <FormText>
                {allowance.value &&
                  <span>
                    <FormattedNumber value={allowance.value} />
                    {` ${translateUnit(allowance.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.ENVIRONMENTAL' })} colon={false}>
              <FormText>
                {environmental.value &&
                  <span>
                    <FormattedNumber value={environmental.value} />
                    {` ${translateUnit(environmental.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.CHEM_ANALYSIS' })} colon={false}>
              <FormText>
                {chemAnalysis.value &&
                  <span>
                    <FormattedNumber value={chemAnalysis.value} />
                    {` ${translateUnit(chemAnalysis.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
          <Col md={3} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'taskList.REFRIGRANT' })} colon={false}>
              <FormText>
                {refrigrant.value &&
                  <span>
                    <FormattedNumber value={refrigrant.value} />
                    {` ${translateUnit(refrigrant.unit)}`}
                  </span>
                }
              </FormText>
            </FormItem>
          </Col>
        </Row>
      </Div>

      <Wrapper>
        <Table
          headerTitle={intl.formatMessage({
            id: 'order.taskList.OPERATIONS',
          })}
          data={operations}
          totalDataCount={operations.length}
          fullWidth={true}
          columns={getOperationsColumns()}
          renderCustomHeader={renderHeader}
        />
      </Wrapper>
    </Div>
  );
};

TaskList.propTypes = {
  taskList: PropTypes.object,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(TaskList);
